import * as React from 'react';
import { useButton } from '@react-aria/button';
import { useMenuTrigger } from '@react-aria/menu';
import { useMenuTriggerState } from '@react-stately/menu';

var useSelectRoot = function useSelectRoot(menuSettings) {
  var triggerRef = React.useRef(null);
  var state = useMenuTriggerState(menuSettings || {});
  var _useMenuTrigger = useMenuTrigger({}, state, triggerRef),
    menuTriggerProps = _useMenuTrigger.menuTriggerProps,
    menuProps = _useMenuTrigger.menuProps;
  var _useButton = useButton(menuTriggerProps, triggerRef),
    buttonProps = _useButton.buttonProps;
  return {
    triggerRef: triggerRef,
    menuProps: menuProps,
    buttonProps: buttonProps,
    state: state
  };
};

export { useSelectRoot };
//# sourceMappingURL=useSelectRoot.js.map
